import { SectionBgView } from '../../ui_canvas_engine/SectionBgView.ts';
import { PIXI } from '@colonist/pixi';
import { UIGameAchievementBackgroundView } from '../ui_game_achievement/UIGameAchievementBackgroundView.ts';
import { TextView } from '../../ui_canvas_engine/TextView.ts';
import { SpriteView } from '../../ui_canvas_engine/SpriteView.ts';
import { GameFont } from '../../GameFont.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { Sprites } from '../UIGameImageDictionary.ts';
import { UIGameGoToPointAnimation } from '../../ui_canvas_engine/animation/UIGameGoToPointAnimation.ts';
import { UIGameHoverResourceInfoView } from '../UIGameHoverResourceInfoView.ts';
import { CANVAS_CARD_RATIO, GameColor } from '@colonist/ui-game';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
export class UIGameBeginnerModeGoalView extends SectionBgView {
    drawCheckBox() {
        const checkBoxDimension = this.initialHeight * 0.6;
        const checkBoxWidth = checkBoxDimension;
        const checkBoxHeight = checkBoxDimension;
        this.checkBox = new UIGameAchievementBackgroundView(checkBoxWidth, checkBoxHeight);
        this.checkBox.y = (this.initialHeight - this.checkBox.height) / 2;
        this.addChild(this.checkBox);
    }
    drawCheckMark() {
        this.checkMark = new SpriteView(0, 0, this.checkBox.width, this.checkBox.height, this.checkBox, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_check));
        this.checkMark.visible = false;
    }
    drawGoalText(text) {
        const x = this.checkBox.width * 1.3;
        const width = this.initialWidth - this.x;
        this.goalText = new TextView(text, x, 0, width, this.initialHeight, this, GameFont.Size.L, GameColor.getColor(GameColor.Color.White));
    }
    drawIcon(icon) {
        if (icon == undefined) return;
        const isMobile = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI && !UIUtilsEjsVariables.isUserOnTabletApp;
        const iconHeight = isMobile ? this.initialHeight * 0.8 : this.initialHeight * 0.5;
        const iconWidth = icon.width / icon.height * iconHeight;
        const iconX = this.goalText.x + this.goalText.width + this.checkBox.width * 0.3;
        this.goalIcon = new SpriteView(iconX, 0, iconWidth, iconHeight, this, icon);
        this.goalIcon.centerYInParent();
    }
    completeGoal() {
        var _this_resourceInfo;
        if (this.isCompleted()) return;
        this.checkMark.visible = true;
        this.goalText.changeStyle({
            fill: GameColor.getColor(GameColor.Color.GreenLink)
        });
        (_this_resourceInfo = this.resourceInfo) === null || _this_resourceInfo === void 0 ? void 0 : _this_resourceInfo.destroy();
    }
    animateUp() {
        if (this.hasAnimatedUp) return;
        const destinationPoint = new PIXI.Point(this.x, this.y - this.initialHeight * 0.55);
        this.animation = new UIGameGoToPointAnimation(this, destinationPoint, 0.2).start();
        this.hasAnimatedUp = true;
    }
    showRequiredResources(cardsInHand) {
        var _this_resourceInfo;
        if (this.requiredResources == undefined) return;
        const isMobile = UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI && !UIUtilsEjsVariables.isUserOnTabletApp;
        (_this_resourceInfo = this.resourceInfo) === null || _this_resourceInfo === void 0 ? void 0 : _this_resourceInfo.destroy();
        this.resourceInfo = new UIGameHoverResourceInfoView(this.requiredResources, this, this, cardsInHand, false);
        this.resourceInfo.x = isMobile ? this.goalIcon.x + this.goalIcon.width + this.initialHeight : this.x + this.initialWidth * 0.1;
        this.resourceInfo.y = this.goalText.y + (isMobile ? 0 : this.goalText.height);
        this.resourceInfo.height = isMobile ? this.initialHeight * 0.9 : this.initialHeight * 0.6;
        this.resourceInfo.width = this.resourceInfo.height * this.requiredResources.length / CANVAS_CARD_RATIO;
    }
    isCompleted() {
        return this.checkMark.visible;
    }
    destroy(options) {
        var _this_animation, _this_resourceInfo;
        (_this_animation = this.animation) === null || _this_animation === void 0 ? void 0 : _this_animation.stop();
        (_this_resourceInfo = this.resourceInfo) === null || _this_resourceInfo === void 0 ? void 0 : _this_resourceInfo.destroy();
        super.destroy(options);
    }
    constructor(x, y, width, height, parent, text, icon, goalResources){
        super(x, y, width, height, parent), this.hasAnimatedUp = false;
        this.initialWidth = width;
        this.initialHeight = height;
        this.requiredResources = goalResources;
        this.drawCheckBox();
        this.drawCheckMark();
        this.drawGoalText(text);
        this.drawIcon(icon);
    }
}
